module.exports = __webpack_public_path__ + "static/media/sygnet.dba7f081.svg";